import { render, staticRenderFns } from "./BoxOverlay.vue?vue&type=template&id=5a15216e&scoped=true&"
import script from "./BoxOverlay.vue?vue&type=script&lang=js&"
export * from "./BoxOverlay.vue?vue&type=script&lang=js&"
import style0 from "./BoxOverlay.vue?vue&type=style&index=0&id=5a15216e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a15216e",
  null
  
)

export default component.exports